export default __webpack_public_path__ + "static/media/not-found.4861ae77.svg";